import { type SupportedPlatform, supportedPlatform } from './constants';

type BoxmapType = 'BOOKING' | 'BLABLACAR';

export interface PartnerBoxMapData {
	type: BoxmapType;
	message: string;
	url: string;
	img: string;
	shortMessage?: string;
	tracking?: string;
}

const webPlatforms = [supportedPlatform.WebDesktop, supportedPlatform.WebMobile];

export function getBoxmapsOrder(platform: SupportedPlatform): BoxmapType[] {
	if (webPlatforms.includes(platform)) {
		return ['BOOKING', 'BLABLACAR'];
	}

	return ['BLABLACAR', 'BOOKING'];
}

export { getBlablacarBoxMapData } from './blablacar';
